module.exports = __webpack_public_path__ + "static/media/100x800_PT3.482b6392.gif";